import { create } from 'zustand';
import { WhiteLabelStore } from './whiteLabelStore';

export const useWhiteLabelStore = create<WhiteLabelStore>()((set) => ({
    settings: null,
    isLoading: false,
    error: null,
    setWhiteLabelSettings: (settings) =>
        set({
            settings: settings,
            error: null, // Clear any previous errors
        }),
    setLoading: (loading) =>
        set({
            isLoading: loading,
        }),
    setError: (error) =>
        set({
            error,
            isLoading: false,
        }),
    clearWhiteLabelSettings: () =>
        set({
            settings: null,
            isLoading: false,
            error: null,
        }),
}));
